export var ProductAlias;
(function (ProductAlias) {
    ProductAlias["CONTA_DIGITAL"] = "conta-digital";
    ProductAlias["COBRANCAS"] = "cobrancas";
    ProductAlias["CONTABILIDADE_DIGITAL"] = "contabilidade-digital";
    ProductAlias["BENEFICIOS"] = "beneficios";
    ProductAlias["DOMINIO_RECOMPENSAS"] = "programa-fidelidade-dominio";
})(ProductAlias || (ProductAlias = {}));
export var SuperAppProduct;
(function (SuperAppProduct) {
    SuperAppProduct["PARA_VOCE"] = "superapp_empregado";
    SuperAppProduct["MINHA_EMPRESA"] = "superapp_minha-empresa";
    SuperAppProduct["MEU_ESCRITORIO"] = "superapp_meu-escritorio";
})(SuperAppProduct || (SuperAppProduct = {}));
export var ApiProductStatus;
(function (ApiProductStatus) {
    ApiProductStatus["AVAILABLE"] = "AVAILABLE";
    ApiProductStatus["ACTIVATING"] = "ACTIVATING";
    ApiProductStatus["ACTIVE"] = "ACTIVE";
    ApiProductStatus["DEACTIVATED"] = "DEACTIVATED";
    ApiProductStatus["NOT_APPROVED"] = "NOT_APPROVED";
})(ApiProductStatus || (ApiProductStatus = {}));
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["CONTRACTED"] = "contracted";
    ProductStatus["NOT_CONTRACTED"] = "not-contracted";
    ProductStatus["ACTIVATE"] = "activate";
    ProductStatus["ACTIVE"] = "active";
    ProductStatus["ANALYSIS"] = "analysis";
    ProductStatus["LOADING"] = "loading";
    ProductStatus["NOT_APPROVED"] = "not-approved";
})(ProductStatus || (ProductStatus = {}));
